// useCanSeeCounts — controls visibility of exact inventory numbers across the app.
// Rule: ONLY admin users see exact numbers (255, 143, 125, ...). Everyone else —
// anonymous visitors AND logged-in regular users — see vague magnitude language.
// This protects the moat (anti-scrape, anti-copy) and keeps the brand premium.
// Owner decision (Sep 2026): inventory numbers are hidden for EVERYONE, admins included.
export default function useCanSeeCounts() {
  return false;
}
